async function requestJson(path) {
  const response = await fetch(path, {
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`API 请求失败：${response.status} ${response.statusText}`);
  }

  return response.json();
}

export async function getPublicCategories() {
  const response = await requestJson("/api/v1/categories");

  if (!response || !Array.isArray(response.data)) {
    throw new Error("分类接口响应格式无效");
  }

  return response.data;
}

export async function getPublicResources({
  categoryId,
  keyword,
  page,
  pageSize,
}) {
  const searchParams = new URLSearchParams();

  if (categoryId !== undefined && categoryId !== null) {
    searchParams.set("categoryId", String(categoryId));
  }

  if (keyword && keyword.trim()) {
    searchParams.set("keyword", keyword.trim());
  }

  searchParams.set("page", String(page));
  searchParams.set("pageSize", String(pageSize));

  const response = await requestJson(
    `/api/v1/resources?${searchParams.toString()}`
  );

  if (
    !response ||
    !Array.isArray(response.data) ||
    !response.meta ||
    typeof response.meta.totalPages !== "number"
  ) {
    throw new Error("资源接口响应格式无效");
  }

  return response;
}
